
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/access/[[...slug]]",
      function () {
        return require("private-next-pages/access/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/access/[[...slug]]"])
      });
    }
  